import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'ab-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  // @Input() errorContextData: LayoutServiceContextData;

  @Input() rendering: ComponentRendering;

  home: any;

  constructor(renderer: Renderer2) {
    renderer.addClass(document.getElementsByTagName('main')[0], 'main-center');
  }

  ngOnInit() {
    this.home = this.rendering.fields.home;
  }

  goToPrevious() {
    window.history.back();
  }
}
